<template>
    <div class="component-wrapper">
        <alert v-if="error_code" class="uk-alert-danger"
             :data="{title: error_message,
             html: error_code,
             closeable:true}"></alert>
        <div class="uk-section create-user-main">
            <div class="uk-container">
                <div class="uk-form-horizontal uk-margin-large uk-form-width-large uk-margin-auto" action="#">
                        <form-container form_title="Create Account" :fieldList="formFields" :resetSignal="resetSignal"
                                        @output="processFormData" @input="processInput"
                                        :success_message="success_message"></form-container>
                </div>
                <div v-if="submitted">
<!--                    <h3> Check Your Email To Confirm Your Account </h3>-->
                </div>
                <div v-if="error">
                    <h3>oops. Looks like somethign went wrong</h3>
                    {{error}}
                </div>
            </div>

        </div>
        <div v-if="invite_info" class="uk-section uk-section-primary uk-preserve-color">
            <div  class="uk-section uk-section-primary uk-preserve-color">
                <div class="uk-container">

                    <div class="uk-panel uk-light uk-margin-medium">
                        <h3>What We Already Know From Your Invite</h3>
                    </div>

                    <div class="uk-grid-match uk-child-width-expand@m" uk-grid>
                        <div>
                            <div class="uk-card uk-card-default uk-card-body">
                                <p>First Name: {{ invite_info.employee.first_name }}</p>
                                <p>Last Name: {{ invite_info.employee.last_name }}</p>
                                <p>Email: {{invite_info.email}}</p>

                            </div>
                        </div>
                        <div>
                            <div class="uk-card uk-card-default uk-card-body">
                                <p>Position Type: {{invite_info.employee.position_type}}</p>
                                <p>Organization: {{invite_info.employee.organization.display_name}}</p>
                                <p>Organization Type: {{invite_info.employee.organization.type}}</p>
                            </div>
                        </div>

                    </div>
                    <button class="uk-button uk-button-secondary">THIS ISNT ME!</button>

                </div>
            </div>



        </div>
<!--                    <div v-else>-->
<!--      <alert class="uk-alert-danger"-->
<!--             :data="{title:'This invite cant be used', body:'This invite has either already been used, has a bad id, or is too old. Contact the person who sent you the invite, and ask them to try again!'}"></alert>-->
<!--            </div>-->
    </div>
</template>

<script>
  import FloatFieldInput from "./theme/Input.vue"
  import formContainer from "./theme/formContainer.vue"
  import apiCall from '../store/apicall.js'
  	import Alert from "./theme/Alert.vue"
    export default {
        name: "createUser",
        		components: {
                    FloatFieldInput,
                    formContainer,
                    Alert,
                },
        data: function () {
            return {
                formFields: [
                ['last_name'],
                ['employee_id'],
                ['createUsername'],
                ['password'],
                ['confirmPassword'],
                    ['email'],
                ],
                success_message: "All done. We are logging you in now.",
                submit_success: false,
                submitted: false,
                invite_info: false,
                invite_code: false,
                error: false,
                error_code: null,
                stale_invite: false,
                resetSignal: false,
                error_message: "That didnt work. Please try one of the following options.",
            }
        },
        methods: {
            login: function(_t, username, password) {
              function continueLogin(_t) {
                if (_t.$store.state.globalAlert.data){
                if (_t.$store.state.globalAlert.data.alert_type == 'not_logged_in') {
                  _t.$store.dispatch('globalAlertReset', {}).then(
                          function () {
                            console.log("RESET ALERT")
                          }).catch(function (error) {
                    console.log(error)
                  })
                }
                }

                if (_t.next) {
                  window.location.href='/dashboard/'
                } else {
                  window.location.href='/dashboard/'
                }
              }
				_t.$store.dispatch('login', {'username': username, 'password': password}).then(() => {
					// _t.$connect();
                  console.log("LOGIN RESPONSE", _t.$store.state.user)
                  if (_t.$store.state.user.error){
                    _t.error_code = "<h3>Please try one of the following:</h3> <ul><li>Try again. Hey maybe you will remember right?</li><li>Reset your password using the button below. You will need the email tied to your account</li><li>Contact us! You can contact us via the CONTACT link in the menu.</li>"
                    _t.resetSignal = true
                  } else {
                    continueLogin(_t)
                  }

				}).catch(function(error){
				    console.log("ERROR", error)
				    if (!error){
				      continueLogin(_t)
                  } else {
                    _t.error_code = error
                  }

                }).then(function() {
                  _t.resetSignal = false
                })
            },

            processFormData: function (output) {
                this.submitted = true;
                console.log(output);
                let submit_form = {}

                if (this.invite_info){
                    submit_form['id'] = this.invite_info.employee.id
                    submit_form['last_name'] = this.invite_info.employee.last_name
                    submit_form['email'] = this.invite_info.email

                } else{
                    submit_form['id'] = output.employee_id;
                    submit_form['last_name'] = output.last_name
                    submit_form['email'] = output.email
                }
                submit_form['username'] = output.createUsername;
                submit_form['password'] = output.password;
                console.log(submit_form)
                let _t = this;
                apiCall.post('accounts/create-user/', submit_form).then(
                    function(response){
                        console.log(response);
                        if (response.status == 200){
                            if ('id' in response.data){
                                _t.submit_success = true;
                                _t.user_data = response.data
                                _t.login(_t, submit_form['username'], submit_form['password'])
                            } else {
                                _t.error = response.data
                            }
                        } else {

                        }

                    }
                )
            },
            processInput: function(input){
                console.log(input)
        },

        },
        computed: {
            focused: function(){
                if(this.loginForm){
                    return "Go To: Sign Up"
                }
                return "Already have a WageUp 1.0 Username? Click Here to Login"
            }
        },
        mounted() {
            this.invite_code = this.$route.query.id;
            if (this.invite_code){
                    let _t = this;
                    console.log("GETTING INVITE DATA...")
                    apiCall.get('/accounts/invite/?invite_code=' + this.invite_code,).then(
                    function(response){
                        if (response == "This invite has already been used or is stale."){
                            console.log("STALE INVITE!")
                            _t.stale_invite = true;
                            // _t.invite_info =
                            // _t.invite_info.employee = {}
                            // _t.invite_info.employee.first_name = 'Unknown'
                            // _t.invite_info.employee.last_name = 'Unknown'
                        } else {
                            console.log(response)
                            _t.invite_info = response
                            _t.formFields = _t.formFields.splice(2,3)
                            console.log(_t.invite_info, "INVITE INFO")

                        }

                    });
            }

        }
    }
</script>

<style lang="less" scoped>

    .uk-section-primary{
        padding-top:10px !important;
    }

    .uk-section-primary button{
        margin-top:10px;
    }

    .uk-card-body p{
        margin: 0px;
    }

</style>
